/**
 * First we will load all of this project's JavaScript dependencies which
 * includes Vue and other libraries. It is a great starting point when
 * building robust, powerful web applications using Vue and Laravel.
 */
import Chart from 'chart.js';
import Multiselect from 'vue-multiselect'
import Notifications from 'vue-notification';
import DatePicker from 'vue2-datepicker';
import 'vue2-datepicker/index.css';
import VueMask from 'v-mask'
import Vue from 'vue';
import './livewireListeners';
import VueRouter from "vue-router";
import SBHealthPlans from "./components/app/SBHealthPlans.vue";

require('./bootstrap');

window.Vue = Vue;



Vue.use(Notifications);
Vue.use(DatePicker);
Vue.use(VueMask);
Vue.use(VueRouter);

/**
 * The following block of code may be used to automatically register your
 * Vue components. It will recursively scan this directory for the Vue
 * components and automatically register them with their "basename".
 *
 * Eg. ./components/ExampleComponent.vue -> <example-component></example-component>
 */

// const files = require.context('./', true, /\.vue$/i)
// files.keys().map(key => Vue.component(key.split('/').pop().split('.')[0], files(key).default))

Vue.component('sb-health-plan', require('./components/app/SBHealthPlans').default);
Vue.component('wellness-chart', require('./components/app/WellnessChart').default);
Vue.component('my-benefits', require('./components/app/MyBenefit').default);
Vue.component('sb-notifications', require('./components/app/SBNotifications').default);
Vue.component('sb-resources', require('./components/app/SBResources').default);
Vue.component('sb-supplements', require('./components/app/SBSupplements').default);
Vue.component('sb-supplements-add-edit', require('./components/app/SBSupplementsAddEdit').default);
Vue.component('sb-allergies', require('./components/app/SBAllergies').default);
Vue.component('sb-allergies-add-edit', require('./components/app/SBAllergiesAddEdit').default);
Vue.component('sb-immunizations', require('./components/app/SBImmunizations').default);
Vue.component('sb-immunizations-add-edit', require('./components/app/SBImmunizationsAddEdit').default);
Vue.component('sb-conditions', require('./components/app/SBConditions').default)
Vue.component('sb-conditions-add-edit', require('./components/app/SBConditionsAddEdit').default)
Vue.component('sb-prescriptions', require('./components/app/SBPrescriptions').default);
Vue.component('sb-prescriptions-add-edit', require('./components/app/SBPrescriptionsAddEdit').default)
Vue.component('sb-profile', require('./components/app/SBProfile').default)
Vue.component('sb-basic-information', require('./components/app/SBBasicInformation').default)
Vue.component('sb-send-phr', require('./components/app/SBSendPHR').default)
Vue.component('sb-emergency-contacts', require('./components/app/SBEmergencyContacts').default)
Vue.component('sb-content', require('./components/app/SBContent').default)
Vue.component('sb-notes', require('./components/app/SBNotes').default)
Vue.component('sb-help', require('./components/app/SBHelp').default)
Vue.component('sb-verify', require('./components/app/SBVerify').default)
Vue.component('sb-searchable-health-library', require('./components/app/SBSearchableHealthLibrary').default)
Vue.component('sb-message-center', require('./components/app/SBMessageCenter').default)

Vue.component('multiselect', Multiselect);
Vue.component('auto-logout', require('./components/AutoLogout').default)
Vue.component('sb-forms', require('./components/app/sbForms').default);
Vue.component('sliding-menu-component', require('./components/app/SlidingMenuComponent').default);

const routes = [
    {
        path: '/employee-benefits',
        component: SBHealthPlans,
        name: 'healthplans',
        children: [
            {
                path: ':slug',
                name: 'healthplans.detail',
                component: SBHealthPlans,
            },
        ]
    },
]

const router = new VueRouter({routes, mode: 'history'})

/**
 * Next, we will create a fresh Vue application instance and attach it to
 * the page. Then, you may begin adding components to this application
 * or customize the JavaScript scaffolding to fit your unique needs.
 */
window.addEventListener('load', function() {
    const app = new Vue({
        el: '#app',
        router,
        components: {
            Multiselect,
        },
        mounted() {
            Livewire.start();
        },
        methods: {
            _handleErrors: function(items, selector)
            {
                $('.has-error').removeClass('has-error')
                $('.help-block').remove()

                for (var error in items['errors']) {
                    if (items['errors'].hasOwnProperty(error)) {
                        var text = error;
                        var parts = text.split('.');
                        var name = parts.pop();
                        var el = $(selector + ' [name="'+name+'"]')
                        el.closest('.form-group').addClass('has-error')
                        $( '<p class="help-block">'+(items['errors'][error].join(', '))+'</p>' ).insertAfter(selector + ' [name="'+name+'"]');
                    }
                }
            },
        }
    });

    $('.modal-card').modal({
        show: true,
    })

    $('.modal-card-viewed').click(function() {
        const id = $(this).data('id');
        const campaignId = $(this).data('campaign-id');
        $.get(`/api/report-viewed-cards/${id}/${campaignId}`);
    })

    $('#opt-in-button').click(function() {
        $('.modal-card').modal('toggle');
        $('#sbhealth-thank-you-card').modal('toggle');
        const id = $(this).data('id')
        $.get(`/api/report-wellness-opt-in/${id}`)
    });

    $('#helmss-assessment-button').click(function() {
        $('.modal-card').modal('toggle');
    });

    $('#dob-register').on('keyup', function () {
        var val = $(this).val().replace(/\D/g, '');
        if (val.length > 2) {
            val = val.slice(0, 2) + '/' + val.slice(2);
        }
        if (val.length > 5) {
            val = val.slice(0, 5) + '/' + val.slice(5);
        }
        $(this).val(val);
    });

    $('#register-check-group-security-features').click(function() {
        const appcode = $('#appcode').val();

        $.get('/api/group-security-features-by-app-code', { appcode: appcode })
            .done(function(data) {
                if(data.Status === true) {
                    $('#register-show-app-code-error').attr('hidden', true);
                    $('#register-first-name').attr('hidden', false);
                    $('#register-last-name').attr('hidden', false);
                    if(data.Data.companySecurityFeatures.require_ssn == true) {
                        $('#register-ssn').attr('hidden', false);
                        $('#ssn').attr('required', true);
                    } else {
                        $('#ssn').attr('required', false);
                        $('#register-ssn').attr('hidden', true);
                    }
                    $('#register-dob').attr('hidden', false);
                    $('#register-complete-form').attr('hidden', false);
                } else {
                    $('#register-show-app-code-error').attr('hidden', false);
                    $('#register-first-name').attr('hidden', true);
                    $('#register-last-name').attr('hidden', true);
                    $('#register-ssn').attr('hidden', true);
                    $('#register-dob').attr('hidden', true);
                    $('#register-complete-form').attr('hidden', true);
                }
            })
            .fail(function(jqXHR, textStatus, errorThrown) {
                //
            });
    });

    $('#appcode').keypress(function(event) {
        if (event.keyCode === 13) {
            event.preventDefault();
            $('#register-check-group-security-features').click();
        }
    });
})
window.bus = new Vue();
window.moment = require('moment');
Vue.use(require('vue-resource'));
Vue.http.headers.common['X-CSRF-TOKEN'] = document.head.querySelector('meta[name="csrf-token"]').content;

